import { Reveal, Eyebrow } from "@/components/Reveal";
import { ContactInfo } from "@/components/contatti/ContactInfo";
import { ContactMap } from "@/components/contatti/ContactMap";
import { ContactForm } from "@/components/contatti/ContactForm";

export default function Contatti() {
    return (
        <section id="contatti" data-testid="contatti-section" className="bg-tl-dark2 py-20 md:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
                <Reveal>
                    <Eyebrow number="07" label="Contatti" />
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-6 font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
                        Parliamo del tuo progetto
                        <span className="text-tl-orange">.</span>
                    </h2>
                </Reveal>
                <div className="mt-14 grid gap-14 lg:grid-cols-2 lg:gap-16">
                    <div>
                        <ContactInfo />
                        <Reveal delay={0.32}>
                            <ContactMap />
                        </Reveal>
                    </div>
                    <Reveal delay={0.15}>
                        <ContactForm />
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
